import {
  defineComponent,
  PropType,
  VNode,
} from 'vue';
import { isHelloFamilyApp } from '~mall/common/env/env';
import { getStylesBinder } from '~mall/common/utils/styles';
import styles from './index.module.less';
import { uiMgr } from '~mall/common/uiMgr';

const cx = getStylesBinder(styles);

export default defineComponent({
  name: 'NavBar',
  props: {
    title: {
      type: String,
      default: '',
    },
    rightText: {
      type: String,
      default: '',
    },
    rightCallBack: {
      type: Function as PropType<{ (): void } | undefined>,
      default: undefined,
    },
    leftCallBack: {
      type: Function as PropType<{ (): void } | undefined>,
      default: undefined,
    },
    scopedSlots: {
      type: Object as PropType<{
        title: () => VNode | string | null,
      }>,
      default: () => ({}),
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  setup: (props, { slots }) => {
    const onClickLeft = () => {
      if (props.leftCallBack) {
        props.leftCallBack();
      } else {
        uiMgr.popPage();
      }
    };

    const onClickRight = () => {
      if (props.rightCallBack) {
        props.rightCallBack();
      }
    };

    return () => {
      if (!isHelloFamilyApp) {
        return null;
      }

      const {
        title,
        rightText,
        fixed,
      } = props;
      return (
        <div class={cx('header', { header_fixed: fixed })}>
          <div class={cx('header__safe-area')}></div>
          <van-nav-bar
            left-arrow
            right-text={rightText || ''}
            border={false}
            scopedSlots={{
              title: () => (
                slots.title
                  ? slots.title()
                  : (title || '')
              ),
            }}
            onclick-left={onClickLeft}
            onclick-right={onClickRight}
          />
        </div>
      );
    };
  },
});
